import { createReducer, on } from '@ngrx/store';
import { IEmailTemplate } from '@core/state/entities/email-templates/email-template.entity';
import { defaultEntityState } from '@core/state/entities/entity';
import { adminActions } from '@core/actions/admin.actions';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesWithIds,
} from '@core/state/entities/entity.helpers';
import { entityKey } from '@core/state/entities/entity-name-map';

export const emailTemplateReducer = createReducer(
  defaultEntityState<IEmailTemplate>(),
  on(adminActions.emailTemplatesLoaded, (state, props) =>
    mergeEntityState(entityKey.emailTemplates, state, props)
  ),
  on(
    adminActions.emailTemplateUpdated,
    adminActions.emailTemplateCreated,
    (state, props) => mergeEntityState(entityKey.emailTemplates, state, props)
  ),
  on(adminActions.emailTemplateDeleted, (state, props) =>
    removeEntitiesWithIds(state, [props.id])
  )
);
